import React, { useState, useContext, useEffect } from "react";
import { fetchPracticeTeam } from "../../apis";

const PracticeTeamContext = React.createContext({});

const PracticeTeamProvider = ({ practiceTeamId, ...props }) => {
  const [practiceTeam, setPracticeTeam] = useState(null);

  const loadPracticeTeam = async () => {
    setPracticeTeam(await fetchPracticeTeam(practiceTeamId));
  };

  useEffect(() => {
    loadPracticeTeam();
  }, [practiceTeamId]);

  if (!practiceTeam) {
    return null;
  }

  return (
    <PracticeTeamContext.Provider
      {...props}
      value={{
        practiceTeam,
        loadPracticeTeam,
      }}
    />
  );
};

export const usePracticeTeam = () => {
  const context = useContext(PracticeTeamContext);

  if (context === undefined) {
    throw new Error('usePracticeTeam must be used within a PracticeTeamProvider');
  }
  return context;
};

export default PracticeTeamProvider;
